/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_P3dInputs */

const en_mk_sol_agensi_p3d = /** @type {(inputs: Mk_Sol_Agensi_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The brand rules live in one or two heads. The moment those people take leave the output feels different, and the client notices.`)
};

const id_mk_sol_agensi_p3d = /** @type {(inputs: Mk_Sol_Agensi_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan brand ada di kepala satu-dua orang. Begitu mereka cuti, hasilnya terasa berbeda dan klien menyadarinya.`)
};

/**
* | output |
* | --- |
* | "The brand rules live in one or two heads. The moment those people take leave the output feels different, and the client notices." |
*
* @param {Mk_Sol_Agensi_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_p3d = /** @type {((inputs?: Mk_Sol_Agensi_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_p3d(inputs)
	return en_mk_sol_agensi_p3d(inputs)
});